// Decisions about the draft of a post being written. The post form does
// the store calls; these say which ones.

export const hasContent = (newStatus) =>
  !!(
    newStatus.status ||
    newStatus.spoilerText ||
    newStatus.files.length ||
    newStatus.poll != null ||
    newStatus.quote != null
  )

// 'save' a changed post with content, 'abandon' a saved draft that became
// empty, else 'none'
export const draftStep = ({
  disabled,
  inhibited,
  saveable,
  draftId,
  newStatus,
}) => {
  if (disabled || inhibited) return 'none'
  if (hasContent(newStatus)) return saveable ? 'save' : 'none'
  return draftId ? 'abandon' : 'none'
}

// the draft a form opens with: the one asked for, else the first one for
// the same reply or edit; a new post starts clean unless one is asked for
export const findDraft = (drafts, { draftId, type, refId, disabled }) => {
  if (disabled || (!draftId && type === 'new')) return null
  if (draftId && drafts.has(draftId)) return drafts.get(draftId)
  return (
    [...drafts.values()].find(
      (draft) => draft.type === type && draft.refId === refId,
    ) ?? null
  )
}

// the post's fields, each taken from the draft when the draft has it
export const loadDraft = (newStatus, draft) =>
  Object.fromEntries(
    Object.entries(newStatus).map(([key, value]) => [key, draft[key] ?? value]),
  )

// the form a saved draft opens in: a reply or a quote under its post, an
// edit of its post, or a new post
export const formAttrs = (draft, refStatus) => {
  if (draft.type === 'edit') return { statusId: draft.refId }
  if (draft.type === 'reply') {
    return { repliedStatus: refStatus, quoting: !!draft.quote?.thread }
  }
  return {}
}
